import { css } from '@emotion/core';
import { variables } from '../../../cssInJs';

export default {
  photoSlide: css({
    margin: 'auto',
    '.image-gallery-left-nav, .image-gallery-right-nav': {
      color: variables.primaryColor,
      filter: 'none',
      '&:hover': {
        color: variables.primaryColor,
      },
    },
  }),
};
